import { toast } from 'react-hot-toast';

// Store to track if buttons are currently disabled
const disabledButtons = new Set();

// Custom toast function with button disable functionality
export const delayedToast = {
  success: (message, options = {}, buttonId = null) => {
    // If button is disabled, don't proceed
    if (buttonId && disabledButtons.has(buttonId)) {
      return;
    }
    
    // Disable button for 5 seconds
    if (buttonId) {
      disabledButtons.add(buttonId);
    }
    
    toast.success(message, {
      duration: 4000,
      ...options
    });
    
    // Re-enable button after 5 seconds
    if (buttonId) {
      setTimeout(() => {
        disabledButtons.delete(buttonId);
      }, 5000);
    }
  },
  
  error: (message, options = {}, buttonId = null) => {
    // If button is disabled, don't proceed
    if (buttonId && disabledButtons.has(buttonId)) {
      return;
    }
    
    // Disable button for 5 seconds
    if (buttonId) {
      disabledButtons.add(buttonId);
    }
    
    toast.error(message, {
      duration: 4000,
      ...options
    });
    
    // Re-enable button after 5 seconds
    if (buttonId) {
      setTimeout(() => {
        disabledButtons.delete(buttonId);
      }, 5000);
    }
  },
  
  info: (message, options = {}, buttonId = null) => {
    // If button is disabled, don't proceed
    if (buttonId && disabledButtons.has(buttonId)) {
      return;
    }
    
    // Disable button for 5 seconds
    if (buttonId) {
      disabledButtons.add(buttonId);
    }
    
    toast(message, {
      duration: 4000,
      ...options
    });
    
    // Re-enable button after 5 seconds
    if (buttonId) {
      setTimeout(() => {
        disabledButtons.delete(buttonId);
      }, 5000);
    }
  }
};

// Clear all disabled buttons (useful for cleanup)
export const clearDisabledButtons = () => {
  disabledButtons.clear();
};

// Check if a button is currently disabled
export const isButtonDisabled = (buttonId) => {
  return disabledButtons.has(buttonId);
};

// Manually enable a button
export const enableButton = (buttonId) => {
  disabledButtons.delete(buttonId);
};
